{
  "cameraCard": {
    "text": "Connected",
    "text2": "Disconnected",
    "text3": "Open viewer",
    "label": "Camera settings",
    "label2": "Recording history"
  },
  "cameraFilterBar": {
    "label": "All",
    "label2": "Connected",
    "label3": "Disconnected",
    "placeholder": "Search by camera name, area name, or tag",
    "button": "Filter",
    "label4": "Connection status",
    "label5": "Camera type",
    "label6": "Area",
    "label7": "Tag",
    "placeholder2": "Select tags"
  },
  "cameraGrid": {
    "text": "No cameras match",
    "text2": "the current filters."
  },
  "cameraGridHeader": {
    "text": " cameras"
  },
  "cameraSettingsDialog": {
    "enqueueSnackbar": "Up to {{MAX_CAMERA_TAGS}} tags can be set.",
    "enqueueSnackbar2": "Tags updated",
    "enqueueSnackbar3": "The tags couldn't be updated.",
    "text": "Updating...",
    "title": "Camera settings",
    "label": "Device name",
    "label2": "Area",
    "label3": "Device ID",
    "label4": "Serial number",
    "label5": "Management number",
    "label6": "Memo",
    "label7": "Tags",
    "placeholder": "Select tags",
    "text2": "Up to ",
    "text3": " tags can be set (current:"
  },
  "useStreamViewState": {
    "label": "All"
  },
  "stream": {
    "title": "Live view"
  },
  "streamViewModeToggle": {
    "ariaLabel": "Grid view (large)",
    "ariaLabel2": "Grid view (small)",
    "ariaLabel3": "Map view"
  },
  "cameraActionPopover": {
    "ariaLabel": "Close menu",
    "text": "Open viewer",
    "text2": "Camera settings"
  },
  "mapSelectBar": {
    "ariaLabel": "Select map",
    "text": " cameras",
    "text2": "Map"
  },
  "streamMapView": {
    "text": "The maps couldn't be retrieved.",
    "text2": "The map couldn't be opened.",
    "alt": "Floor plan of {{name}}",
    "text3": "No maps",
    "text4": "Registered maps appear here."
  }
}
